// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1dYKe","label":"Radio_label__3ODQA","checkMark":"Radio_checkMark__LzBUa","disabled":"Radio_disabled__W2umY"};